module.exports = __webpack_public_path__ + "static/SignaturaMonolineScript-Regular-228be729fbcd984a28990972ffbc3abe.woff";